<template>
  <div>

    <v-row
      justify="center"
      class="mt-5 graphContent"
      style="margin: 0px; margin-bottom: -18px"
    >
      <LatestReportFilter @handleFilter="handleFilter" @exportsToExcel="exportsToExcel" />
    </v-row>

    <!-- <LatestReportFilter @filterData="handleFilter" /> -->
    <div v-if="!this.$store.state.loadingData" class="requests-chart-classification">
      <table-component
        :showSelect="false"
        itemKey="id"
        :headers="headers"
        :pagination="this.$store.state.pagination"
        :limit="$store.state.counterOfShow"
        :items="this.$store.state.tableData"
        :loading="loading"
        @refresh="getTableData"
        v-model="page"
        :options.sync="tableOptions"
        :sortBy.sync="tableSortBy"
        :requestReferralData="requestReferralData"
      >
        <template #[`item.name`]="{ item }">
          <span v-if="!item.name"></span>
          <v-tooltip bottom v-else>
            <template #activator="{ on }">
              <span v-on="on">{{
                item.name.length > 30
                  ? item.name.substring(0, 30) + "..."
                  : item.name
              }}</span>
            </template>
            <div class="font-weight-bold">{{ item.name }}</div>
          </v-tooltip>
        </template>
      </table-component>
    </div>
    <div class="loadingMore" v-else>
      <LoadingMore />
    </div>
     <!-- chart -->
     <div style="box-shadow: 0 0 0 0 !important;display: none;" class="adminGraph">
      <div v-if="!getDataDone">
        <div style="margin-top: 40px" v-if="!loading">
          <highcharts :options="chartOptions" style="height: 600px"></highcharts>
        </div>
      </div>
      <div v-else class="loader">
        <img src="../../../../assets/Comp-2.gif" />
      </div>
    </div>

  </div>
</template>

<style lang="scss">
.loadingMore {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 10px;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
</style>

<script>
import Axios from "axios";
import LatestReportFilter from "./LatestReportFilter.vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts-vue";

export default {
  name: "AdminLatestReport",
  components: {LatestReportFilter,highcharts: Chart},

  data() {
    return {
      page: 1,
      body: {},
      requestReferralData:{},
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,
      loadingData: false,
      selected_requests: [],
      iconToggle: false,
      headers: [
        { text: "الحملة", value: "name" },
        { text: "المنصة", value: "المنصة" },
        { text: "البراند", value: "البراند" },
        { text: "مجموع الايجابي", value: "مجموع الايجابي" },
        { text: "نسبة الايجابي", value: "نسبة الايجابي" },
        { text: "مجموع السلبي", value: "مجموع السلبي" },
        { text: "نسبة السلبي", value: "نسبة السلبي" },
        { text: "مجموع بدون", value: "مجموع بدون" }, 
        { text: "مجموع المرفوع", value: "مجموع المرفوع" },
        { text: "نسبة المرفوع", value: "نسبة المرفوع" },
        { text: "مجموع المفرغ", value: "مجموع المفرغ" },
        { text: "نسبة المفرغ", value: "نسبة المفرغ" },
        { text: "المجموع", value: "المجموع" },
      ],
      horizontalData: [],
      verticalData1: [],
      verticalData2: [],
      verticalData3: [],
      verticalData4: [],

      chartData: [],
      getDataDone: false,
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "تقرير روابط الحملة",
        },
        xAxis: {
          min: 0,
          title: {
            text: "روابط الحملة",
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: "المجموع",
          },
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true,
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: "مجموع التصنيفات السلبيه",
            data: [],
            color: "#FF0000",
          },
          {
            name: "مجموع التصنيفات الايجابية",
            data: [],
            color: "#00FF00",
          },
          {
            name: "مجموع المفرغة",
            data: [],
            color: "#0000FF",
          },
          {
            name: "مجموع المرفوعه",
            data: [],
            color: "#0000FF",
          },
          {
            name: "مجموع بدون",
            data: [],
            color: "#FFA500",
          },
        ],
      },
      // table sorting state
      tableOptions: { sortBy: [], sortDesc: [] },
      tableSortBy: [],
    };
  },

  watch: {
    page(val) {
      this.getTableData(val);
      this.getTableSumsData();
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getTableData(this.page);
          this.getTableSumsData();
        }
      },
    },

    // react to header sort clicks
    tableOptions: {
      deep: true,
      handler(newVal, oldVal) {
        // when sort column or direction changes, reload from first page
        if (!newVal) return;
        const changed = JSON.stringify({ b: oldVal?.sortBy, d: oldVal?.sortDesc }) !== JSON.stringify({ b: newVal.sortBy, d: newVal.sortDesc });
        if (changed) {
          this.page = 1;
          this.getTableData(1);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },

  },

  methods: {
    mapSortField(field) {
      // map table header value -> backend field
      const map = {
        name: 'name',
        'المنصة': 'platform',
        'البراند': 'brand',
        'مجموع السلبي': 'negative_requests_count',
        'مجموع الايجابي': 'positive_requests_count',
        'مجموع المفرغ': 'completed_requests_count',
        'مجموع المرفوع': 'send_requests_count',
        'مجموع بدون': 'null_requests_count',
        'المجموع': 'sum_of_row',
      };
      return map[field] || '';
    },
    getSortQuery() {
      const by = this.tableOptions?.sortBy?.[0];
      const desc = this.tableOptions?.sortDesc?.[0] === true;
      const backendField = this.mapSortField(by);
      if (!backendField) return '';
      const dir = desc ? 'desc' : 'asc';
      return `&sort_by=${encodeURIComponent(backendField)}&sort_dir=${dir}`;
    },
    handleOrderRequest(item) {
      this.$router.push({
        name: "request_details",
        params: { id: item.request_id },
      });
    },
    handleOrdersRequest(item) {
      this.$router.push({
        name: "logs",
        params: { id: item.request_id },
      });
    },



    handleFilter(val) {
      // console.log("valval", val);
      this.body = new FormData();

      if (val.startDate) {
        this.body.append("start_date", val.startDate);
      }

      if (val.endDate) {
        this.body.append("end_date", val.endDate);
      }

  
      if (val.range) {
        this.body.append("range", val.range);
      }

      if (val.referral_id.length) {
        val.referral_id.forEach((item, index) => {
          console.log(item)
          this.body.append([`referral_id[${index}]`], item.text);
        });
      }

      if (val.brand.length) {
        val.brand.forEach((item, index) => {
          this.body.append([`brand[${index}]`], item.text);
        });
      }

      if (val.platform.length) {
        val.platform.forEach((item, index) => {
          this.body.append([`platform[${index}]`], item.text);
        });
      }

      if (val.dayNumber) {
        this.body.append("range", val.dayNumber);
      }

      this.getTableData(1, "getDataDone");
      this.getTableSumsData();
    },

    setTbData(items) {
      this.$store.state.tableData.push({
        id: items.id,
        // request_id: items.request_id,
        name: items.name,
        "المنصة": items.platform,
        "البراند": items.brand,
        "مجموع السلبي": items.negative_requests_count,
        "نسبة السلبي": items.negative_requests_percentage,
        "مجموع الايجابي": items.positive_requests_count,
        "نسبة الايجابي": items.positive_requests_percentage,
        "مجموع المفرغ": items.completed_requests_count,
        "نسبة المفرغ": items.completed_requests_percentage,
        "مجموع المرفوع": items.send_requests_count,
        "نسبة المرفوع": items.send_requests_percentage,
        "مجموع بدون": items.null_requests_count,
        "المجموع" : items.sum_of_row,
      });
    },

    // handleFilter(val) {
    //   this.$store.state.tableData = [];
    //   val.data.map((res) => {
    //     this.setTbData(res);
    //   });
    //   this.chartData = [];
    //   this.chartOptions.xAxis.categories = [];
    //   this.chartOptions.series[0].data = [];
    //   this.chartOptions.series[1].data = [];
    //   this.chartOptions.series[2].data = [];
    //   this.drawChart(val.chart);
    // },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      const sortQuery = this.getSortQuery();
      Axios.post(
        `${this.$store.state.url}/employee/admin/RequestReferralReport?page=${count}&per_page=${this.$store.state.counterOfShow}${sortQuery}`,
        this.body,
        {
          headers: this.request_headers(),
        }
      ).then((res) => {
        res.data.payload.data.map((item) => {
          this.setTbData(item);
        });

        this.$store.state.pagination = {
          limit: 3,
          count: res.data.payload.sum_of_resources,
        };

        this.drawChart(res.data.payload.data);
        this.loading = false;
      });
    },

    getTableSumsData() {
      Axios.post(
        `${this.$store.state.url}/employee/admin/RequestReferralReportSum`,this.body,
        {
          headers: this.request_headers(),
        }
      ).then((res) => {
        this.requestReferralData = res.data.payload
        // this.loading = false;
      });
    },

    drawChart(data) {

      // redraw chart 
      this.chartData = [];
      this.chartOptions.xAxis.categories = [];
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[1].data = [];
      this.chartOptions.series[2].data = [];
      this.chartOptions.series[3].data = [];

      this.chartData = data;
      this.horizontalData = this.chartData.map((item) => item.value);
      this.verticalData1 = this.chartData.map((item) => item.negative_requests_count);
      this.verticalData2 = this.chartData.map((item) => item.positive_requests_count);
      this.verticalData3 = this.chartData.map((item) => item.completed_requests_count);
      this.verticalData4 = this.chartData.map((item) => item.null_requests_count);
      this.chartOptions.xAxis.categories = this.horizontalData;
      this.chartOptions.series[0].data = this.verticalData1;
      this.chartOptions.series[1].data = this.verticalData2;
      this.chartOptions.series[2].data = this.verticalData3;
      this.chartOptions.series[3].data = this.verticalData4;
      this.loading = false;
    },

    exportsToExcel() {
      const table = document.querySelector(".requests-chart-classification table");
      this.exportTableToCsv(table, "تصنيفات روابط الحملة");
    },
  },

  created() {
    this.$store.state.tableData = [];
    // this.getTableData(1);
  },
};
</script>
